import type { FC, PropsWithChildren } from "react";
import styles from "./styles.module.scss";

export const Content: FC<PropsWithChildren> = ({ children }) => {
  return <section className={styles.content}>{children}</section>;
};
